var bookshelf = require("../index-extended");
require("./Building");
require("./Media");
require("./Resolution");
require("./Mandate");

require("./MeetingResolution");

module.exports = bookshelf.model("Meeting", {
  entityName: "Meeting",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "meeting",
  building() {
    return this.belongsTo("Building");
  },
  media() {
    return this.belongsTo("Media");
  },
  // invitation_pdf() {
  //   return this.belongsTo("invitation_media_id", "Media");
  // },
  agenda_pdf() {
    return this.belongsTo("Media", "agenda_media_id");
    // return this.belongsTo("agenda_media_id", "Media");
  },

  // HACK: .. needed for list table .. sort by number of resolutions
  meeting_resolutions() {
    return this.hasMany("MeetingResolution", "meeting_id");
  },
  // ???: ??
  mandates() {
    return this.hasMany("Mandate", "meeting_id");
  },

  parse(res) {
    if (res.minutes) res.minutes = JSON.parse(res.minutes);
    if (res.freezed_meeting_details)
      res.freezed_meeting_details = JSON.parse(res.freezed_meeting_details);
    if (res.allowed_modalities) res.allowed_modalities = JSON.parse(res.allowed_modalities);
    return res;
  },
  format(attrs) {
    if (attrs.minutes) attrs.minutes = JSON.stringify(attrs.minutes);
    if (attrs.freezed_meeting_details)
      attrs.freezed_meeting_details = JSON.stringify(attrs.freezed_meeting_details);
    if (attrs.allowed_modalities)
      attrs.allowed_modalities = JSON.stringify(attrs.allowed_modalities);

    delete attrs["$id"];
    delete attrs["resolutions"];
    delete attrs["resolutions_count"];
    delete attrs["has_resolutions_without_keys"];
    delete attrs["mandates"];
    delete attrs["building"];
    delete attrs["meeting_resolutions"];
    delete attrs["invitation_pdf"];
    delete attrs["agenda_pdf"];
    delete attrs["minutes_pdf"];
    // ***
    delete attrs["minutes_media"];
    delete attrs["presence_media"];
    delete attrs["invitation_media"];
    delete attrs["agenda_media"];

    return attrs;
  },
});
